import React from 'react'
import { Heading } from '@alefeducation/ui-elements-library-core'
import styled from 'styled-components'

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
`
export const Title = () => {
  return (
    <TitleWrapper data-testid="title">
      <Heading variant="heading-xl" weight="bold" color="primary.100">
        Audit Logs
      </Heading>
    </TitleWrapper>
  )
}
